import { useEffect, useState } from "react";

import { fetchGraphQL } from "../../../services/api-raindrop";

import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import TimeAgo from "../../../ui-components/time-ago/time-ago.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";

const NotificationRow = ({ text, createdAt, isRead }) => {
  return (
    <RaindropCard>
      <div className="flex flex-row w-full dark:bg-color-dark-background-secondary items-center ">
        <div className="flex flex-col gap-1 text-left dark:text-color-dark-text-secondary">
          <h1 className="dark:text-color-dark-text-primary font-bold">
            {text}
          </h1>
          <p className="text-sm">
            <TimeAgo dateStr={createdAt} />
          </p>
        </div>

        {!isRead && (
          <div className="w-3 h-3 bg-color-raindrop-primary rounded-full ml-auto" />
        )}
      </div>
    </RaindropCard>
  );
};

const RaindropNotifications = ({ userCurrent }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!userCurrent) {
      return;
    }
    fetchGraphQL(`
      query {
        notificationObjects {
          id
          text
          createdAt
          isRead
        }
      }
    `).then((response) => {
      if (response.errors) {
        console.error(response.errors);
        return;
      }

      setNotifications(response.data.notificationObjects);

      // After 2 seconds, mark all notifications as read
      setTimeout(() => {
        fetchGraphQL(`
          mutation {
            notificationObjectsMarkAllAsRead
          }
        `).then((response) => {
          if (response.errors) {
            console.error(response.errors);
            return;
          }
        });
      }, 2000);
    });
  }, [userCurrent]);

  return (
    <div
      className={
        "flex flex-col h-full items-center gap-6 py-8 overflow-y-scroll overflow-x-clip no-scrollbar px-2"
      }
    >
      {notifications.length === 0 && (
        <RaindropMotionFadeUp>
          <RaindropCard>
            <h1 className="text-color-dark-text-secondary">
              No notifications yet
            </h1>
          </RaindropCard>
        </RaindropMotionFadeUp>
      )}

      {notifications && (
        <div className="flex flex-col gap-4 w-full">
          {notifications.map((notification, i) => (
            <RaindropMotionFadeUp key={notification.id}>
              <NotificationRow
                text={notification.text}
                createdAt={notification.createdAt}
                isRead={notification.isRead}
              />
            </RaindropMotionFadeUp>
          ))}
        </div>
      )}
    </div>
  );
};

export default RaindropNotifications;
